var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center price"},[_c('font-awesome-icon',{staticClass:"mr-1",attrs:{"icon":"tag"}}),_c('span',[(_vm.value || (_vm.items && _vm.items.length > 0))?[_vm._v("ab ")]:_vm._e(),_c('b',[_vm._v(_vm._s(_vm._f("formatPrice")(_vm.price)))])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }